import { render, staticRenderFns } from "./flyOldmanEdit.vue?vue&type=template&id=3c9a9f9d&scoped=true"
import script from "./flyOldmanEdit.vue?vue&type=script&lang=js"
export * from "./flyOldmanEdit.vue?vue&type=script&lang=js"
import style0 from "./flyOldmanEdit.vue?vue&type=style&index=0&id=3c9a9f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a9f9d",
  null
  
)

export default component.exports